/* eslint-disable react/no-array-index-key */
import { useState, useEffect } from 'react';
import {
  Button, Container, Grid, IconButton, TextField, Typography,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/system';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SearchIcon from '@mui/icons-material/Search';
import TableComponent from './table';
import { useUploadCreativeDocumentMutation, useListCreativeDocumentQuery } from '../../../../../graphql/generated/graphql';
import DropZone from '../../../components/dropzone';
import { IFiles } from '../../../../config/interfaces';

import './index.scss';
import ItemFile from '../../../components/dropzone/itemFile';
import CircularLoading from '../../../components/common/CircularLoading';
import { useLoginState } from '../../../../hooks/loginInfo';
import { UserTypes } from '../../../../config/enums';
import { setAlertDescription } from '../../../../hooks/actions';
import DropzoneFullScreen from './dropzone-fullscreen';

const CreativeDocsPage = () => {
  const params = useParams();
  const [title, setTitle] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [uploadFiles] = useUploadCreativeDocumentMutation();
  const [canEditing] = useState(useLoginState().can_edit.get());
  const loginState = useLoginState();

  const userType = loginState.user_type.get();

  const {
    data, loading, error, refetch,
  } = useListCreativeDocumentQuery({
    variables: {
      project_id: params.projectId ?? '',
    },
  });
  const listCreativeDocument = data?.listCreativeDocument;

  useEffect(() => {
    if (refetch) {
      refetch()
    }
  }, [])

  const saveFiles = async (type: string, jsonFile?: IFiles, nameFilesError?: string) => {
    setIsLoading(true);
    const files: IFiles[] = []

    if (type === 'link') {
      files.push({ name: title, link_url: link, base64: '' })
    } else if (type === 'file') {
      if (jsonFile) {
        files.push({ name: jsonFile.name, base64: jsonFile.base64, link_url: '' })
      }
    }

    try {
      await uploadFiles({
        variables: {
          project_id: params.projectId ?? '',
          documents: files.map((f) => ({
            file_name: f.name,
            document: f.base64 || undefined,
            link_url: f.link_url || undefined,
          })),
        },
      }).then((res) => {
        setIsLoading(false);
        if (nameFilesError === '') {
          setAlertDescription({
            open: true,
            message: 'The File/Link has been uploaded succesfully',
            severity: 'success',
          })
        }
        if (res.data?.uploadCreativeDocument) {
          setTitle('');
          setLink('');
          if (refetch) {
            refetch();
          }
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  const getCount = () => {
    if (listCreativeDocument && listCreativeDocument?.count) {
      return listCreativeDocument?.count;
    }
    return 0;
  }

  return loading ? <CircularLoading /> : (
    <>
      <Typography
        component="p"
        variant="h1"
        sx={{
          fontWeight: 500,
        }}
      >
        Creative Documents
      </Typography>
      <Box component="br" />
      <Container>
        <>
          {canEditing &&
            <Grid container >
              <Grid item xs={12} md={5} className='dropzone-container'>
                <Box>
                  <DropZone handleZone={saveFiles} />
                </Box>
              </Grid>
              <Grid item xs={12} md={1}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  height: '90%',
                  flexDirection: 'column',
                }}
                >
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    color: '#9CA3AF',
                    height: '100%',
                  }}
                  >
                    <Box sx={{
                      borderLeft: '1px solid #9CA3AF',
                      flexGrow: 1,
                      width: '1px',
                    }}
                    />
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        height: '60px',
                      }}
                    >
                      Or
                    </Box>
                    <Box sx={{
                      borderLeft: '1px solid #9CA3AF',
                      flexGrow: 1,
                      width: '1px',
                    }}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <Box>
                    <TextField
                      style={{
                        marginTop: '0px',
                      }}
                      fullWidth
                      margin="normal"
                      name="title"
                      label="Title"
                      id="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                      style={{
                        marginTop: '0px',
                      }}
                      fullWidth
                      margin="normal"
                      name="link"
                      label="Link"
                      id="link"
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    className="text-black"
                    onClick={() => saveFiles('link')}
                    disabled={!(title && link)}
                  >
                    Add link
                  </Button>
                </Box>
              </Grid>
            </Grid>
          }
          <Box component="br" />
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography
                  component="span"
                  variant="h2"
                  sx={{
                    display: 'flex',
                    fontWeight: 500,
                  }}
                >
                  Files
                  <Typography className="p-gray" sx={{ pl: 1 }}>
                    {` (${getCount()} items found)`}
                  </Typography>
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              />
            </Box>
            <TableComponent
              documents={listCreativeDocument?.creative_document}
              isLoading={isLoading}
              canEditing={canEditing}
            />
          </Box>
        </>
      </Container>
      <DropzoneFullScreen handleZone={saveFiles}/>
    </>
  )
}

export default CreativeDocsPage;
